import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TranslatePipe, TranslateService } from '@ngx-translate/core';
import { ConfirmationService, MessageService } from 'primeng/api';
import { ButtonModule } from 'primeng/button';
import { TableModule } from 'primeng/table';
import IProductCategory from '../../../_interfaces/IProductCategory';
import { ErrorsService } from '../../../_services/errors/errors.service';
import { ProductsCategoriesService } from '../../../_services/products/products-categories.service';
import { SessionService } from '../../../_services/session/session.service';
import { BaseComponent } from '../../base/base.component';
import { AdminStatePanelComponent } from '../../admin-ui/admin-state-panel/admin-state-panel.component';
import { AdminTableActionsComponent } from '../../admin-ui/admin-table-actions/admin-table-actions.component';
import { AdminListToolbarComponent } from '../../admin-ui/admin-list-toolbar/admin-list-toolbar.component';

@Component({
  standalone: true,
  selector: 'app-table-categories-products',
  templateUrl: './table-categories-products.component.html',
  styleUrls: ['./table-categories-products.component.scss'],
  imports: [
    CommonModule,
    TableModule,
    TranslatePipe,
    ButtonModule,
    AdminStatePanelComponent,
    AdminTableActionsComponent,
    AdminListToolbarComponent,
  ],
})
export class TableCategoriesProductsComponent extends BaseComponent implements OnInit {
  public productsCategories: IProductCategory[] = [];
  public filteredProductsCategories: IProductCategory[] = [];
  public searchValue = '';

  constructor(
    public readonly session: SessionService,
    public readonly confirmationService: ConfirmationService,
    public readonly messageService: MessageService,
    public readonly productsCategoriesService: ProductsCategoriesService,
    public readonly errorsService: ErrorsService,
    public readonly translate: TranslateService,
    public readonly router: Router,
  ) {
    super(session);
  }

  onSearch(value: string): void {
    this.searchValue = value;
    const query = value.trim().toLowerCase();
    if (!query) {
      this.filteredProductsCategories = [...this.productsCategories];
      return;
    }

    this.filteredProductsCategories = this.productsCategories.filter((category) =>
      (category.name || '').toLowerCase().includes(query),
    );
  }

  load(): void {
    this.productsCategoriesService.getByCustomer(this.customers_id).subscribe({
      next: (productsCategories: IProductCategory[]) => {
        this.productsCategories = productsCategories;
        this.onSearch(this.searchValue);
      },
      error: (error) => {
        const code = this.errorsService.getMessageFromProductCategoryError(error);
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('MESSAGES.PRODUCTS.CATEGORIES.ERROR.SUMMARY'),
          detail: this.translate.instant(`MESSAGES.PRODUCTS.CATEGORIES.ERROR.${code}`),
        });
      },
    });
  }

  confirmDelete(category: IProductCategory): void {
    if (!category?.id) {
      return;
    }

    this.confirmationService.confirm({
      header: this.translate.instant('ADMIN.PRODUCTS.CATEGORIES.CONFIRM.DELETE.TITLE'),
      message: this.translate.instant('ADMIN.PRODUCTS.CATEGORIES.CONFIRM.DELETE.TEXT', {
        category: category.name,
      }),
      icon: 'pi pi-exclamation-triangle',
      accept: () => this.delete(category),
    });
  }

  private delete(category: IProductCategory): void {
    if (!category?.id) {
      return;
    }

    this.productsCategoriesService.delete(this.customers_id, category.id).subscribe({
      next: () => {
        this.messageService.add({
          severity: 'success',
          summary: this.translate.instant(
            'MESSAGES.SUCCESS.DELETE.PRODUCT_CATEGORIES.SUMMARY',
          ),
          detail: this.translate.instant(
            'MESSAGES.SUCCESS.DELETE.PRODUCT_CATEGORIES.DETAIL',
          ),
        });
        this.load();
      },
      error: () => {
        this.messageService.add({
          severity: 'error',
          summary: this.translate.instant('MESSAGES.COMMON.500.SUMMARY'),
          detail: this.translate.instant('MESSAGES.COMMON.500.DETAIL'),
        });
      },
    });
  }

  ngOnInit(): void {
    super.ngOnInit();
    this.load();
  }
}
